export default __webpack_public_path__ + "static/media/logo.de1e18e9.png";